$(document).ready(function () {
    // Frontend voucher book form
    let container = $('#voucher-bookform-container');
    let component = $('#voucher-bookform-component');

    window.voucher = null;

    if (component.length > 0) {
        let codeInput = $('#voucher_code', component);
        let codeInputProxy = $('#voucher_code_proxy', component);
        let validateButton = $('#check-voucher-code-btn', component);
        let validFeedback = $('.valid-feedback', container);
        let inValidFeedback = $('.invalid-feedback', container);
        let voucherOverviewPlaceholder = $('#voucher-overview-placeholder');
        let voucherBookformPriceContainer = $('#voucher-bookform-price-container');
        let bookformVouchersPriceContainerLine = $('#bookform-vouchers-price-container-line');

        // Check and format code input
        codeInputProxy.off('input').on('input', function () {
            codeInputProxy.val(uppercaseAndReplaceSpaces(codeInputProxy.val()));
        });

        // Prevent on click enter to submit the form
        codeInputProxy.on('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault(); // Prevents the form submission
                // Trigger the button click event to validate the code.
                validateButton.trigger('click');
                return false;
            }
        });
        // Check voucher code against the online vouchers through AJAX.
        validateButton.off('click keydown').on('click keydown', () => {
            codeInput.val(codeInputProxy.val());
            $('.total-price').html('');

            const clearVoucher = () => {
                inValidFeedback.addClass('d-block');
                inValidFeedback.removeClass('d-none');
                codeInput.val('');
                codeInputProxy.val('');
                component.removeClass('voucher-code-valid');
                voucherOverviewPlaceholder.html('');
                bookformVouchersPriceContainerLine.html('');

            }

            codeInput.val(codeInput.val().trim());

            $.ajax({
                method: "POST",
                url: "/bookings/voucher/check",
                data: {
                    code: codeInput.val()
                },
                async: true,
                cache: false,
            }).done(function (result) {
                if (result.valid) {
                    validFeedback.removeClass('d-none');
                    validFeedback.addClass('d-block');
                    inValidFeedback.removeClass('d-block');
                    inValidFeedback.addClass('d-none');
                    component.addClass('voucher-code-valid');
                    voucherOverviewPlaceholder.html(result.voucher_overview_content);
                    bookformVouchersPriceContainerLine.html(result.voucher_bookform_price_container_line);
                    codeInput.trigger('change');
                    return;
                }

                codeInput.trigger('change');
                validFeedback.removeClass('d-block');
                validFeedback.addClass('d-none');

                clearVoucher();
            });
        });
    }
})
